import { Card, CardContent } from '@/components/ui/card';
import { format } from 'date-fns';
import { SectionHeading, EmptySection } from './shared';

interface ShiftLogRow {
  id: string;
  entry_time: string;
  entry_text: string;
}

interface Props {
  data: ShiftLogRow[];
}

export default function ShiftLogSection({ data }: Props) {
  return (
    <section>
      <SectionHeading id="section-shift-log" title="Shift Log" count={data.length} />
      {data.length === 0 ? (
        <EmptySection name="shift log entries" />
      ) : (
        <div className="mt-2 space-y-2">
          {data.map((row) => (
            <Card key={row.id}>
              <CardContent className="flex gap-4 pt-4">
                <div className="w-20 shrink-0 text-xs font-semibold text-mozaic-teal">
                  {format(new Date(row.entry_time), 'HH:mm')}
                </div>
                <p className="whitespace-pre-wrap text-sm leading-relaxed">
                  {row.entry_text}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </section>
  );
}
